export const FREELANCER_RATINGS_ADMIN_PAGE = () => `/freelancer-ratings`;
